import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//路由重复
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'home',
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "index" */ '@/views/index.vue')
    },
    {   //登录
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue')
    },
    { //注册
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "register" */ '@/views/login/register.vue')
    },
    {//忘记密码
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: () => import(/* webpackChunkName: "register" */ '@/views/login/forgetPassword.vue')
    },
    { //行情
      path: '/quotes',
      name: 'quotes',
      component: () => import(/* webpackChunkName: "quotes" */ '@/views/home/quotes.vue')
    },
    { //交易
      path: '/transaction',
      name: 'transaction',
      component: () => import(/* webpackChunkName: "quotes" */ '@/views/home/transaction.vue')
    },
    { //公告
      path: '/notice',
      name: 'notice',
      component: () => import(/* webpackChunkName: "quotes" */ '@/views/home/notice.vue')
    },
    { //公告详情
      path: '/noticeDetails',
      name: 'noticeDetails',
      component: () => import(/* webpackChunkName: "quotes" */ '@/views/home/noticeDetails.vue')
    },
    { //个人中心
      path: '/userCenter',
      name: 'userCenter',
      component: () => import(/* webpackChunkName: "userCenter" */ '@/views/home/userCenter.vue')
    },
    { //安全中心
      path: '/securityCenter',
      name: 'securityCenter',
      component: () => import(/* webpackChunkName: "securityCenter" */ '@/views/home/securityCenter.vue')
    },
    { //个人认证
      path: '/personalAuthentication',
      name: 'personalAuthentication',
      component: () => import(/* webpackChunkName: "personalAuthentication" */ '@/views/home/personalAuthentication.vue')
    },
    { //初级认证
      path: '/primaryCertification',
      name: 'primaryCertification',
      component: () => import(/* webpackChunkName: "personalAuthentication" */ '@/views/home/primaryCertification.vue')
    },
    { //高级认证
      path: '/advancedCertification',
      name: 'advancedCertification',
      component: () => import(/* webpackChunkName: "personalAuthentication" */ '@/views/home/advancedCertification.vue')
    },
    { //资产
      path: '/assets',
      name: 'assets',
      component: () => import(/* webpackChunkName: "assets" */ '@/views/home/assets.vue')
    },
    { //划转
      path: '/transfer',
      name: 'transfer',
      component: () => import(/* webpackChunkName: "spot" */ '@/views/home/transfer.vue')
    },
    { //提币
      path: '/withdrawMoney',
      name: 'withdrawMoney',
      component: () => import(/* webpackChunkName: "spot" */ '@/views/home/withdrawMoney.vue')
    },
    { //充币
      path: '/chargeMoney',
      name: 'chargeMoney',
      component: () => import(/* webpackChunkName: "chargeMoney" */ '@/views/home/chargeMoney.vue')
    },
    //兑换 
    {
      path: '/exchange',
      name: 'exchange',
      component: () => import(/* webpackChunkName: "exchange" */ '@/views/home/exchange.vue')
    },
    //修改密码 
    {
      path: '/changePassword',
      name: 'changePassword',
      component: () => import(/* webpackChunkName: "exchange" */ '@/views/home/changePassword.vue')
    },
    //资金密码 
    {
      path: '/fundPassword',
      name: 'fundPassword',
      component: () => import(/* webpackChunkName: "fundPassword" */ '@/views/home/fundPassword.vue')
    },
    //币币账户
    {
      path: '/currencyAccount',
      name: 'currencyAccount',
      component: () => import(/* webpackChunkName: "currencyAccount" */ '@/views/home/currencyAccount.vue')
    },
    //合约账户
    {
      path: '/contractAccount',
      name: 'contractAccount',
      component: () => import(/* webpackChunkName: "contractAccount" */ '@/views/home/contractAccount.vue')
    },
    //邮箱
    {
      path: '/mailbox',
      name: 'mailbox',
      component: () => import(/* webpackChunkName: "mailbox" */ '@/views/home/mailbox.vue')
    },
    //app下载页面
    {
      path: '/appDownload',
      name: 'appDownload',
      component: () => import(/* webpackChunkName: "appDownload" */ '@/views/home/appDownload.vue')
    },
  ]
})
